"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  Apply: "Apply",
  Clear: "Clear",
  "Date picker open, choose a date": "Date picker open, choose a date",
  "Date range picker open, select a date range": "Date range picker open, select a date range",
  "End Date": "End Date",
  "Please enter a valid date ({format})": ["Please enter a valid date (", ["format"], ")"],
  "Please select a date after {minDate}": ["Please select a date after ", ["minDate"]],
  "Please select a date before {maxDate}": ["Please select a date before ", ["maxDate"]],
  "Show next month": "Show next month",
  "Show previous month": "Show previous month",
  "Start Date": "Start Date",
  "The selected date is disabled": "The selected date is disabled",
  "The selected date is unavailable. Please select another.": "The selected date is unavailable. Please select another.",
  Today: "Today",
  "Today, {dateStr}": ["Today, ", ["dateStr"]],
  "date picker": "date picker",
  "start date selected": "start date selected",
  to: "to",
  "{dateStr}, select end date": [["dateStr"], ", select end date"],
  "{dateStr}, select start date": [["dateStr"], ", select start date"],
  "{startDate} to {endDate}, choose apply to confirm, or cancel": [["startDate"], " to ", ["endDate"], ", choose apply to confirm, or cancel"]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map